import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const when = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

/**
 * Renders a feedback conversation as chat bubbles. `mineSender` is the sender shown on the
 * right ("You"); the other side is labelled `otherLabel`.
 */
const FeedbackMessages = ({ messages, mineSender, otherLabel }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    {(messages || []).map((m, i) => {
      const mine = m.sender === mineSender;
      return (
        <Box key={i} sx={{ alignSelf: mine ? 'flex-end' : 'flex-start', maxWidth: '85%' }}>
          <Paper
            variant="outlined"
            sx={{ px: 1.5, py: 1, bgcolor: mine ? 'primary.main' : 'grey.100',
              color: mine ? 'primary.contrastText' : 'text.primary',
              borderColor: mine ? 'primary.main' : 'divider' }}
          >
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{m.body}</Typography>
          </Paper>
          <Typography variant="caption" color="text.secondary"
            sx={{ display: 'block', textAlign: mine ? 'right' : 'left', mt: 0.25 }}>
            {mine ? 'You' : otherLabel} · {when(m.createdAt)}
          </Typography>
        </Box>
      );
    })}
  </Box>
);

export default FeedbackMessages;
